module.exports = __webpack_public_path__ + "static/img/IC.17730d5d.svg";